import { DataType, InverterData, ReadWrite, RegisterTable } from '../lib/inverter.model';
import { getBitsValue, isEnabledByBit, updateBitByPosition, updateBitsValue } from '../lib/modbus.utils';

export const getStyleProp = (prop: string) =>
  window.getComputedStyle(document.querySelector('body') as any).getPropertyValue(prop);

export const V3StartUp: Partial<RegisterTable> = {
  ConnectWaitTime: {
    address: 0x0800,
    name: 'ConnectWaitTime',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Waiting time before generate on grid power',
    quantity: 1,
    unit: 'Second',
    custom: {
      translate: 'connectWaitTime',
    },
    limits: {
      min: 1,
      unit: 'Second',
    },
  },
  PowerUpSpeed: {
    address: 0x0801,
    name: 'PowerUpSpeed',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description:
      '100 mean fully power sided in one minute, Other values are calculated based on this',
    quantity: 1,
    custom: {
      translate: 'powerUpSpeed',
    },
    unit: '%Pn/min',
    limits: {
      min: 0,
      max: 300,
      unit: '%',
    },
  },
  ReconnectWaitTime: {
    address: 0x0802,
    name: 'ReconnectWaitTime',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Waiting time after grid fault recovery',
    quantity: 1,
    unit: 'Second',
    custom: {
      translate: 'reconnectWaitTime',
    },
    limits: {
      min: 1,
      unit: 'Second',
    },
  },
  ReconnectPowerUpSpeed: {
    address: 0x0803,
    name: 'ReconnectPowerUpSpeed',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description:
      '100 mean fully power sided in one minute, Other values are calculated based on this',
    quantity: 1,
    custom: {
      translate: 'reconnectPowerUpSpeed',
    },
    unit: '%Pn/min',
    limits: {
      min: 0,
      max: 300,
      unit: '%',
    },
  },
  VoltHighLimit: {
    address: 0x0804,
    name: 'VoltHighLimit',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'Upper limit for starting voltage (Grid side)',
    quantity: 1,
    unit: 'V',
    custom: {
      translate: 'voltHighLimit',
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  VoltLowLimit: {
    address: 0x0805,
    name: 'VoltLowLimit',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'Lower limit for starting Voltage (Grid Side)',
    quantity: 1,
    unit: 'V',
    custom: {
      translate: 'voltLowLimit',
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  FreqHighLimit: {
    address: 0x0806,
    name: 'FreqHighLimit',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'Upper limit for starting frequency (Grid side)',
    quantity: 1,
    unit: 'Hz',
    custom: {
      translate: 'freqHighLimit',
    },
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
  FreqLowLimit: {
    address: 0x0807,
    name: 'FreqLowLimit',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'Lower limit for starting Frequency (Grid Side)',
    quantity: 1,
    unit: 'Hz',
    custom: {
      translate: 'freqLowLimit',
    },
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
  ReconnectVoltHighLimit: {
    address: 0x0808,
    name: 'ReconnectVoltHighLimit',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'Upper limit for reconnected grid voltage',
    quantity: 1,
    unit: 'V',
    custom: {
      translate: 'reconnectVoltHighLimit',
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  ReconnectVoltLowLimit: {
    address: 0x0809,
    name: 'ReconnectVoltLowLimit',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'Lower limit For reconnected grid voltage',
    quantity: 1,
    unit: 'V',
    custom: {
      translate: 'reconnectVoltLowLimit',
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  ReconnectFreqHighLimit: {
    address: 0x080a,
    name: 'ReconnectFreqHighLimit',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'Upper limit for reconnected grid frequency',
    quantity: 1,
    unit: 'Hz',
    custom: {
      translate: 'reconnectFreqHighLimit',
    },
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
  ReconnectFreqLowLimit: {
    address: 0x080b,
    name: 'ReconnectFreqLowLimit',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'Lower limit for reconnected grid frequency',
    quantity: 1,
    unit: 'Hz',
    custom: {
      translate: 'reconnectFreqLowLimit',
    },
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
};

export const V3VoltageProtection: Partial<RegisterTable> = {
  VoltageConfig: {
    address: 0x0840,
    name: 'VoltageConfig',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
    Bit0：OV1 protection enable bits
    Bit1：OV2 protection enable bits
    Bit2：OV3 protection enable bit
    Bit3：UV1 protection enable bits
    Bit4：UV2 protection enable bits
    Bit5：UV3 Protection enable bits
    Bit6：over voltage protection  enable bits(ten minutes time period)
    `,
    quantity: 1,
    unit: '',
    custom: {
      translate: 'voltageConfig',
      isEnabledFn: (_: Partial<InverterData>) => false,
      bitFunctions: [{
        order: 1,
        translate: 'firstOvervoltageProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 0),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.VoltageConfig as number, bit, 0),
      }, {
        order: 4,
        translate: 'secondOvervoltageProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 1),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.VoltageConfig as number, bit, 1),
      }, {
        order: 7,
        translate: 'thirdOvervoltageProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 2),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.VoltageConfig as number, bit, 2),
      }, {
        order: 10,
        translate: 'firstUndervoltageProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 3),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.VoltageConfig as number, bit, 3),
      }, {
        order: 13,
        translate: 'secondUndervoltageProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 4),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.VoltageConfig as number, bit, 4),
      }, {
        order: 16,
        translate: 'thirdUndervoltageProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 5),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.VoltageConfig as number, bit, 5),
      }, {
        order: 19,
        translate: 'tenMinOvervoltageProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 6),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.VoltageConfig as number, bit, 6),
      }],
    },
  },
  RatedVoltage: {
    address: 0x0841,
    name: 'RatedVoltage',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'Grid Rated voltage',
    quantity: 1,
    unit: 'V',
    order: 0,
    custom: {
      translate: 'ratedVoltage',
      graphOptions: {
        id: 'RatedVoltage',
        useOnYAxis: true,
        color: getStyleProp('--green-500'),
        label: 'i18n.report.RatedVoltage',
        plotAsAline: true,
      },
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  FirstOvervoltageProtectionValue: {
    address: 0x0842,
    name: 'FirstOvervoltageProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'OV1 trigger Value',
    quantity: 1,
    unit: 'V',
    order: 2,
    custom: {
      translate: 'firstOvervoltageProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 0),
      graphOptions: {
        id: 'FirstOvervoltageProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--orange-300'),
        label: 'i18n.report.FirstOvervoltageProtectionValue',
      },
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  FirstOvervoltageProtectionTime: {
    address: 0x0843,
    name: 'FirstOvervoltageProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'OV1 trigger time',
    quantity: 1,
    unit: 'ms',
    order: 3,
    custom: {
      translate: 'firstOvervoltageProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 0),
      graphOptions: {
        id: 'FirstOvervoltageProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--orange-300'),
        label: 'i18n.report.FirstOvervoltageProtectionValue',
      },
    },
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  SecondOvervoltageProtectionValue: {
    address: 0x0844,
    name: 'SecondOvervoltageProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'OV2 Trigger Value',
    quantity: 1,
    unit: 'V',
    order: 5,
    custom: {
      translate: 'secondOvervoltageProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 1),
      graphOptions: {
        id: 'SecondOvervoltageProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--red-200'),
        label: 'i18n.report.SecondOvervoltageProtectionValue',
      },
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  SecondOvervoltageProtectionTime: {
    address: 0x0845,
    name: 'SecondOvervoltageProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'OV2 Trigger time',
    quantity: 1,
    unit: 'ms',
    order: 6,
    custom: {
      translate: 'secondOvervoltageProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 1),
      graphOptions: {
        id: 'SecondOvervoltageProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--red-200'),
        label: 'i18n.report.SecondOvervoltageProtectionValue',
      },
    },
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  ThirdOvervoltageProtectionValue: {
    address: 0x0846,
    name: 'ThirdOvervoltageProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'OV3 Trigger value',
    quantity: 1,
    unit: 'V',
    order: 8,
    custom: {
      translate: 'thirdOvervoltageProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 2),
      graphOptions: {
        id: 'ThirdOvervoltageProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--red-500'),
        label: 'i18n.report.ThirdOvervoltageProtectionValue',
      },
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  ThirdOvervoltageProtectionTime: {
    address: 0x0847,
    name: 'ThirdOvervoltageProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'OV3 Trigger Time',
    quantity: 1,
    unit: 'ms',
    order: 9,
    custom: {
      translate: 'thirdOvervoltageProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 2),
      graphOptions: {
        id: 'ThirdOvervoltageProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--red-500'),
        label: 'i18n.report.ThirdOvervoltageProtectionTime',
      },
    },
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  FirstUndervoltageProtectionValue: {
    address: 0x0848,
    name: 'FirstUndervoltageProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'UV1 trigger Value',
    quantity: 1,
    unit: 'V',
    order: 11,
    custom: {
      translate: 'firstUndervoltageProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 3),
      graphOptions: {
        id: 'FirstUndervoltageProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--orange-300'),
        label: 'i18n.report.FirstUndervoltageProtectionValue',
      },
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  FirstUndervoltageProtectionTime: {
    address: 0x0849,
    name: 'FirstUndervoltageProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'UV1 trigger time',
    quantity: 1,
    unit: 'ms',
    order: 12,
    custom: {
      translate: 'firstUndervoltageProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 3),
      graphOptions: {
        id: 'FirstUndervoltageProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--orange-300'),
        label: 'i18n.report.FirstUndervoltageProtectionValue',
      },
    },
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  SecondUndervoltageProtectionValue: {
    address: 0x084a,
    name: 'SecondUndervoltageProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'UV2 Trigger Value',
    quantity: 1,
    unit: 'V',
    order: 14,
    custom: {
      translate: 'secondUndervoltageProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 4),
      graphOptions: {
        id: 'SecondUndervoltageProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--red-200'),
        label: 'i18n.report.SecondUndervoltageProtectionValue',
      },
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  SecondUndervoltageProtectionTime: {
    address: 0x084b,
    name: 'SecondUndervoltageProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'UV2 Trigger time',
    quantity: 1,
    unit: 'ms',
    order: 15,
    custom: {
      translate: 'secondUndervoltageProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 4),
      graphOptions: {
        id: 'SecondUndervoltageProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--red-200'),
        label: 'i18n.report.SecondUndervoltageProtectionValue',
      },
    },
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  ThirdUndervoltageProtectionValue: {
    address: 0x084c,
    name: 'ThirdUndervoltageProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'UV3 Trigger value',
    quantity: 1,
    unit: 'V',
    order: 17,
    custom: {
      translate: 'thirdUndervoltageProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 5),
      graphOptions: {
        id: 'ThirdUndervoltageProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--red-500'),
        label: 'i18n.report.ThirdUndervoltageProtectionValue',
      },
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
  ThirdUndervoltageProtectionTime: {
    address: 0x084d,
    name: 'ThirdUndervoltageProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'UV3 Trig+K852:K863ger Time',
    quantity: 1,
    unit: 'ms',
    order: 18,
    custom: {
      translate: 'thirdUndervoltageProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 5),
      graphOptions: {
        id: 'ThirdUndervoltageProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--red-500'),
        label: 'i18n.report.ThirdUndervoltageProtectionValue',
      },
    },
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  TenMinOvervoltageProtectionValue: {
    address: 0x084e,
    name: 'TenMinOvervoltageProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'Over Voltage protection for Ten minutes range',
    quantity: 1,
    unit: 'V',
    order: 20,
    custom: {
      translate: 'tenMinOvervoltageProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.VoltageConfig as number), 6),
    },
    limits: {
      min: 0,
      max: 300,
      unit: 'V',
    },
  },
};

export const V3FrequencyProtection: Partial<RegisterTable> = {
  FrequencyConfig: {
    address: 0x0880,
    name: 'FrequencyConfig',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
    Bit0：OF1 protection enable bits
    Bit1：OF2 protection enable bits
    Bit2：OF3 protection enable bit
    Bit3：UF1 protection enable bits
    Bit4：UF2 protection enable bits
    Bit5：UF3 Protection enable bits
    `,
    quantity: 1,
    custom: {
      translate: 'frequencyConfig',
      isEnabledFn: (data: Partial<InverterData>) => false,
      bitFunctions: [{
        order: 1,
        translate: 'firstOverfrequencyProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 0),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyConfig as number, bit, 0),
      }, {
        order: 4,
        translate: 'secondOverfrequencyProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 1),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyConfig as number, bit, 1),
      }, {
        order: 7,
        translate: 'thirdOverfrequencyProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 2),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyConfig as number, bit, 2),
      }, {
        order: 10,
        translate: 'firstUnderfrequencyProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 3),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyConfig as number, bit, 3),
      }, {
        order: 13,
        translate: 'secondUnderfrequencyProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 4),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyConfig as number, bit, 4),
      }, {
        order: 16,
        translate: 'thirdUnderfrequencyProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 5),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyConfig as number, bit, 5),
      }],
    },
    unit: '',
  },
  RatedFrequency: {
    address: 0x0881,
    name: 'RatedFrequency',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'Grid Rated Frequency',
    quantity: 1,
    order: 0,
    custom: {
      translate: 'ratedFrequency',
      graphOptions: {
        id: 'RatedFrequency',
        useOnYAxis: true,
        color: getStyleProp('--green-500'),
        label: 'i18n.report.RatedFrequency',
        plotAsAline: true,
      },
    },
    unit: 'Hz',
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
  FirstOverfrequencyProtectionValue: {
    address: 0x0882,
    name: 'FirstOverfrequencyProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'OF1 Trigger Value',
    quantity: 1,
    order: 2,
    custom: {
      translate: 'firstOverfrequencyProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 0),
      graphOptions: {
        id: 'FirstOverfrequencyProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--orange-300'),
        label: 'i18n.report.FirstOverfrequencyProtectionValue',
      },
    },
    unit: 'Hz',
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
  FirstOverfrequencyProtectionTime: {
    address: 0x0883,
    name: 'FirstOverfrequencyProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'OF1 trigger time',
    quantity: 1,
    order: 3,
    custom: {
      translate: 'firstOverfrequencyProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 0),
      graphOptions: {
        id: 'FirstOverfrequencyProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--orange-300'),
        label: 'i18n.report.FirstOverfrequencyProtectionTime',
      },
    },
    unit: 'ms',
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  SecondOverfrequencyProtectionValue: {
    address: 0x0884,
    name: 'SecondOverfrequencyProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'OF2 Trigger Value',
    quantity: 1,
    order: 5,
    custom: {
      translate: 'secondOverfrequencyProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 1),
      graphOptions: {
        id: 'SecondOverfrequencyProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--red-200'),
        label: 'i18n.report.SecondOverfrequencyProtectionValue',
      },
    },
    unit: 'Hz',
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
  SecondOverfrequencyProtectionTime: {
    address: 0x0885,
    name: 'SecondOverfrequencyProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'OF2 Trigger time',
    quantity: 1,
    order: 6,
    custom: {
      translate: 'secondOverfrequencyProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 1),
      graphOptions: {
        id: 'SecondOverfrequencyProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--red-200'),
        label: 'i18n.report.SecondOverfrequencyProtectionTime',
      },
    },
    unit: 'ms',
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  ThirdOverfrequencyProtectionValue: {
    address: 0x0886,
    name: 'ThirdOverfrequencyProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'OF3 Trigger value',
    quantity: 1,
    order: 8,
    custom: {
      translate: 'thirdOverfrequencyProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 2),
      graphOptions: {
        id: 'ThirdOverfrequencyProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--red-500'),
        label: 'i18n.report.ThirdOverfrequencyProtectionValue',
      },
    },
    unit: 'Hz',
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
  ThirdOverfrequencyProtectionTime: {
    address: 0x0887,
    name: 'ThirdOverfrequencyProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'OF3 Trigger Time',
    quantity: 1,
    order: 9,
    custom: {
      translate: 'thirdOverfrequencyProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 2),
      graphOptions: {
        id: 'ThirdOverfrequencyProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--red-500'),
        label: 'i18n.report.ThirdOverfrequencyProtectionTime',
      },
    },
    unit: 'ms',
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  FirstUnderfrequencyProtectionValue: {
    address: 0x0888,
    name: 'FirstUnderfrequencyProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'UF1 trigger Value',
    quantity: 1,
    order: 11,
    custom: {
      translate: 'firstUnderfrequencyProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 3),
      graphOptions: {
        id: 'FirstUnderfrequencyProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--orange-300'),
        label: 'i18n.report.FirstUnderfrequencyProtectionValue',
      },
    },
    unit: 'Hz',
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
  FirstUnderfrequencyProtectionTime: {
    address: 0x0889,
    name: 'FirstUnderfrequencyProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'UF1 trigger time',
    quantity: 1,
    order: 12,
    custom: {
      translate: 'firstUnderfrequencyProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 3),
      graphOptions: {
        id: 'FirstUnderfrequencyProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--orange-300'),
        label: 'i18n.report.FirstUnderfrequencyProtectionTime',
      },
    },
    unit: 'ms',
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  SecondUnderfrequencyProtectionValue: {
    address: 0x088a,
    name: 'SecondUnderfrequencyProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'UF2 Trigger Value',
    quantity: 1,
    order: 14,
    custom: {
      translate: 'secondUnderfrequencyProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 4),
      graphOptions: {
        id: 'SecondUnderfrequencyProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--red-200'),
        label: 'i18n.report.SecondUnderfrequencyProtectionValue',
      },
    },
    unit: 'Hz',
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
  SecondUnderfrequencyProtectionTime: {
    address: 0x088b,
    name: 'SecondUnderfrequencyProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'UF2 Trigger time',
    quantity: 1,
    order: 15,
    custom: {
      translate: 'secondUnderfrequencyProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 4),
      graphOptions: {
        id: 'SecondUnderfrequencyProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--red-200'),
        label: 'i18n.report.SecondUnderfrequencyProtectionTime',
      },
    },
    unit: 'ms',
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
  ThirdUnderfrequencyProtectionValue: {
    address: 0x088c,
    name: 'ThirdUnderfrequencyProtectionValue',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'UF3 Trigger value',
    quantity: 1,
    order: 17,
    custom: {
      translate: 'thirdUnderfrequencyProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 5),
      graphOptions: {
        id: 'ThirdUnderfrequencyProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--red-500'),
        label: 'i18n.report.ThirdUnderfrequencyProtectionValue',
      },
    },
    unit: 'Hz',
    limits: {
      min: 40,
      max: 70,
      unit: 'Hz',
    },
  },
  ThirdUnderfrequencyProtectionTime: {
    address: 0x088d,
    name: 'ThirdUnderfrequencyProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'UF3 Trigger Time',
    quantity: 1,
    order: 18,
    custom: {
      translate: 'thirdUnderfrequencyProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyConfig as number), 5),
      graphOptions: {
        id: 'ThirdUnderfrequencyProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--red-500'),
        label: 'i18n.report.ThirdUnderfrequencyProtectionTime',
      },
    },
    unit: 'ms',
    limits: {
      min: 1,
      unit: 'ms',
    },
  },
};

export const V3DCIProtection: Partial<RegisterTable> = {
  DCIConfig: {
    address: 0x08c0,
    name: 'DCIConfig',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
    Bit0：DCI  level 1 protection
    Bit1：DCI  level 2 protection
    Bit2：DCI level 3 protection
    Bit3：DCI testing enable bot
    `,
    custom: {
      translate: 'dCIConfig',
      isEnabledFn: (data: Partial<InverterData>) => false,
      bitFunctions: [{
        order: 1,
        translate: 'dCIFirstProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 0),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.DCIConfig as number, bit, 0),
      }, {
        order: 4,
        translate: 'dCISecondProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 1),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.DCIConfig as number, bit, 1),
      }, {
        order: 7,
        translate: 'dCIThirdProtectionValue',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 2),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.DCIConfig as number, bit, 2),
      }, {
        order: 10,
        translate: 'dCITestingEnable',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 3),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.DCIConfig as number, bit, 3),
      }],
    },
    quantity: 1,
    unit: '',
  },
  DCIFirstProtectionValue: {
    address: 0x08c1,
    name: 'DCIFirstProtectionValue',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'DCI level 1 tripping value',
    order: 2,
    custom: {
      translate: 'dCIFirstProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 0),
      graphOptions: {
        id: 'DCIFirstProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--orange-300'),
        label: 'i18n.report.DCIFirstProtectionValue',
      },
    },
    quantity: 1,
    unit: 'mA',
  },
  DCIFirstProtectionTime: {
    address: 0x08c2,
    name: 'DCIFirstProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'DCI level 1 tripping time',
    order: 3,
    custom: {
      translate: 'dCIFirstProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 0),
      graphOptions: {
        id: 'DCIFirstProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--orange-300'),
        label: 'i18n.report.DCIFirstProtectionValue',
      },
    },
    quantity: 1,
    unit: 'ms',
  },
  DCIFirstProtectionProportion: {
    address: 0x08ca,
    name: 'DCIFirstProtectionProportion',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'DCI level 1 protection Ratio',
    order: 4,
    custom: {
      translate: 'dCIFirstProtectionProportion',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 0),
    },
    quantity: 1,
    unit: '%',
  },
  DCISecondProtectionValue: {
    address: 0x08c3,
    name: 'DCISecondProtectionValue',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'DCI level 2 tripping value',
    order: 6,
    custom: {
      translate: 'dCISecondProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 1),
      graphOptions: {
        id: 'DCISecondProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--red-200'),
        label: 'i18n.report.DCISecondProtectionValue',
      },
    },
    quantity: 1,
    unit: 'mA',
  },
  DCISecondProtectionTime: {
    address: 0x08c4,
    name: 'DCISecondProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'DCI level 2 tripping tie',
    order: 7,
    custom: {
      translate: 'dCISecondProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 1),
      graphOptions: {
        id: 'DCISecondProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--red-200'),
        label: 'i18n.report.DCISecondProtectionValue',
      },
    },
    quantity: 1,
    unit: 'ms',
  },
  DCISecondProtectionProportion: {
    address: 0x08cb,
    name: 'DCISecondProtectionProportion',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'DCI level 2 protection Ratio',
    order: 8,
    custom: {
      translate: 'dCISecondProtectionProportion',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 1),
    },
    quantity: 1,
    unit: '%',
  },
  DCIThirdProtectionValue: {
    address: 0x08c5,
    name: 'DCIThirdProtectionValue',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'DCI level 3 tripping value',
    order: 10,
    custom: {
      translate: 'dCIThirdProtectionValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 2),
      graphOptions: {
        id: 'DCIThirdProtectionValue',
        useOnYAxis: true,
        color: getStyleProp('--red-500'),
        label: 'i18n.report.DCIThirdProtectionValue',
      },
    },
    quantity: 1,
    unit: 'mA',
  },
  DCIThirdProtectionTime: {
    address: 0x08c6,
    name: 'DCIThirdProtectionTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'DCI level 3 tripping time',
    order: 11,
    custom: {
      translate: 'dCIThirdProtectionTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 2),
      graphOptions: {
        id: 'DCIThirdProtectionValue',
        useOnXAxis: true,
        color: getStyleProp('--red-500'),
        label: 'i18n.report.DCIThirdProtectionValue',
      },
    },
    quantity: 1,
    unit: 'ms',
  },
  DCIThirdProtectionProportion: {
    address: 0x08cc,
    name: 'DCIThirdProtectionProportion',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'DCI level 3 protection Ratio',
    order: 12,
    custom: {
      translate: 'dCIThirdProtectionProportion',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 2),
    },
    quantity: 1,
    unit: '%',
  },
  DCITestValue1: {
    address: 0x08c7,
    name: 'DCITestValue1',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'DCI phase R testing value',
    order: 13,
    custom: {
      translate: 'dCIPhaseRTestingValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 3),
    },
    quantity: 1,
    unit: 'mA',
  },
  DCITestValue2: {
    address: 0x08c8,
    name: 'DCITestValue2',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'DCI phase S testing value',
    order: 14,
    custom: {
      translate: 'dCIPhaseSTestingValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 3),
    },
    quantity: 1,
    unit: 'mA',
  },
  DCITestValue3: {
    address: 0x08c9,
    name: 'DCITestValue3',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'DCI phase T testing value',
    order: 15,
    custom: {
      translate: 'dCIPhaseTTestingValue',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.DCIConfig as number), 3),
    },
    quantity: 1,
    unit: 'mA',
  },
};

export const V3OverVoltageUnderVoltageDerate: Partial<RegisterTable> = {
  RemoteConfig: {
    address: 0x0900,
    name: 'RemoteConfig',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
    Bit0：Active power derate
    Bit1：remotely on/off control
    Bit2：power derate leading by high AC  voltage
    Bit3：battery charging power derate leading high voltage
    Bit4：battery charging power derate by low voltage
    Bit5：DRM0
    Bit6：logic interface（DRM1-8）
    Bit7: Anti-backflow overload enable bit
    Bit8: Voltage dropout PT curve enable bit
    `,
    quantity: 1,
    section: ['activePowerLimit', 'activeDeratingForGridOverVoltage', 'DRM0', 'logicInterfaceDRM1-8'],
    unit: '',
    custom: {
      translate: 'remoteConfig',
      isEnabledFn: (_: Partial<InverterData>) => false,
      bitFunctions: [{
        translate: 'activeOutputLimit',
        section: ['activePowerLimit'],
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 0),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.RemoteConfig as number, bit, 0),
      }, {
        translate: 'remoteOnOffControl',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 1),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.RemoteConfig as number, bit, 1),
      }, {
        translate: 'powerDerateLeadingByHighACVoltage',
        section: ['activeDeratingForGridOverVoltage'],
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 2),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.RemoteConfig as number, bit, 2),
      }, {
        translate: 'batteryChargingPowerDerateLeadingHighVoltage',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 3),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.RemoteConfig as number, bit, 3),
      }, {
        translate: 'batteryChargingPowerDerateByLowVoltage',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 4),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.RemoteConfig as number, bit, 4),
      }, {
        translate: 'dRM0',
        section: ['DRM0'],
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 5),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.RemoteConfig as number, bit, 5),
      }, {
        translate: 'logicInterface',
        section: ['logicInterfaceDRM1-8'],
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.RemoteConfig as number, bit, 6),
      }, {
        translate: 'antiBackflowOverloadEnable',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 7),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.RemoteConfig as number, bit, 7),
      }, {
        translate: 'voltageDropoutPTCurveEnable',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 8),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.RemoteConfig as number, bit, 8),
      }],
    },
  },
  ActiveOutputLimit: {
    address: 0x0901,
    name: 'ActiveOutputLimit',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'The percentage of active power output',
    quantity: 1,
    section: ['activePowerLimit'],
    unit: '%',
    custom: {
      translate: 'activeOutputLimit',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 0),
    },
  },
  ActiveOutputDownSpeed: {
    address: 0x0902,
    name: 'ActiveOutputDownSpeed',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'active power derating rate',
    quantity: 1,
    section: ['activePowerLimit'],
    unit: '%Pn/min',
    custom: {
      translate: 'activeOutputDownSpeed',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 0),
    },
  },
  GridVoltageDropStart: {
    address: 0x0903,
    name: 'GridVoltageDropStart',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description:
      'the start point of power derate leading by  high grid  voltage',
    quantity: 1,
    section: ['activeDeratingForGridOverVoltage'],
    unit: 'V',
    custom: {
      translate: 'gridVoltageDropStart',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 2),
    },
  },
  GridVoltageDropStop: {
    address: 0x0904,
    name: 'GridVoltageDropStop',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description:
      'the end point of power derate leading by high ac voltage',
    quantity: 1,
    section: ['activeDeratingForGridOverVoltage'],
    unit: 'V',
    custom: {
      translate: 'gridVoltageDropStop',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 2),
    },
  },
  GridVoltageDropMinPower: {
    address: 0x0905,
    name: 'GridVoltageDropMinPower',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description:
      'cut -off power of power derate leading by high ac voltage',
    quantity: 1,
    section: ['activeDeratingForGridOverVoltage'],
    unit: '%',
    custom: {
      translate: 'gridVoltageDropMinPower',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 2),
    },
  },
  OvervoltageDownSpeed: {
    address: 0x0906,
    name: 'OvervoltageDownSpeed',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'power derating rate leading by high ac voltage',
    quantity: 1,
    section: ['activeDeratingForGridOverVoltage'],
    unit: '%Pn/min',
    custom: {
      translate: 'overvoltageDownSpeed',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 2),
    },
  },
  ChgDerateVoltStart: {
    address: 0x0907,
    name: 'ChgDerateVoltStart',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description:
      'the start point of power derate leading by  low grid  voltage',
    quantity: 1,
    unit: 'V',
    custom: {
      translate: 'chgDerateVoltStart',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 4),
    },
  },
  ChgDerateVoltEnd: {
    address: 0x0908,
    name: 'ChgDerateVoltEnd',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description:
      'the end point of power derate leading by low ac voltage',
    quantity: 1,
    unit: 'V',
    custom: {
      translate: 'chgDerateVoltEnd',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 4),
    },
  },
  ChgDerateMinPower: {
    address: 0x0909,
    name: 'ChgDerateMinPower',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description:
      'cut -off power of power derate leading by low ac voltage',
    quantity: 1,
    unit: '%',
    custom: {
      translate: 'chgDerateMinPower',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 4),
    },
  },
  PowerForLogic1: {
    address: 0x090a,
    name: 'PowerForLogic1',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'logic interface 1 corresponding power',
    quantity: 1,
    section: ['logicInterfaceDRM1-8'],
    unit: '%',
    custom: {
      translate: 'powerForLogic1',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
    },
  },
  PowerForLogic2: {
    address: 0x090b,
    name: 'PowerForLogic2',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'logic interface 2 corresponding power',
    quantity: 1,
    section: ['logicInterfaceDRM1-8'],
    unit: '%',
    custom: {
      translate: 'powerForLogic2',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
    },
  },
  PowerForLogic3: {
    address: 0x090c,
    name: 'PowerForLogic3',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'logic interface 3 corresponding power',
    quantity: 1,
    section: ['logicInterfaceDRM1-8'],
    unit: '%',
    custom: {
      translate: 'powerForLogic3',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
    },
  },
  PowerForLogic4: {
    address: 0x090d,
    name: 'PowerForLogic4',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'logic interface 4 corresponding power',
    quantity: 1,
    section: ['logicInterfaceDRM1-8'],
    unit: '%',
    custom: {
      translate: 'powerForLogic4',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
    },
  },
  PowerForLogic5: {
    address: 0x090e,
    name: 'PowerForLogic5',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'logic interface 5 corresponding power',
    quantity: 1,
    section: ['logicInterfaceDRM1-8'],
    unit: '%',
    custom: {
      translate: 'powerForLogic5',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
    },
  },
  PowerForLogic6: {
    address: 0x090f,
    name: 'PowerForLogic6',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'logic interface 6 corresponding power',
    quantity: 1,
    section: ['logicInterfaceDRM1-8'],
    unit: '%',
    custom: {
      translate: 'powerForLogic6',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
    },
  },
  PowerForLogic7: {
    address: 0x0910,
    name: 'PowerForLogic7',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'logic interface 7 corresponding power',
    quantity: 1,
    section: ['logicInterfaceDRM1-8'],
    unit: '%',
    custom: {
      translate: 'powerForLogic7',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
    },
  },
  PowerForLogic8: {
    address: 0x0911,
    name: 'PowerForLogic8',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'logic interface 8 corresponding power',
    quantity: 1,
    section: ['logicInterfaceDRM1-8'],
    unit: '%',
    custom: {
      translate: 'powerForLogic8',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
    },
  },
  RefluxPower: {
    address: 0x0912,
    name: 'RefluxPower',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description:
      'Reflux power (upper limit of VDE4105 safety grid-connected power)',
    quantity: 1,
    unit: '%',
    custom: {
      translate: 'safetyRefluxPower',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 7),
    },
  },
  RefluxOVloadTime: {
    address: 0x0913,
    name: 'RefluxOVloadTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description:
      'Reflux power over load (upper limit of VDE4105 safety grid-connected power)',
    quantity: 1,
    unit: 'ms',
    custom: {
      translate: 'refluxOVloadTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 7),
    },
  },
  LogicDerateSpeed: {
    address: 0x0914,
    name: 'LogicDerateSpeed',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Logical interface derating rate',
    quantity: 1,
    unit: '%Pn/min',
    custom: {
      translate: 'logicDerateSpeed',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
    },
  },
  LogicReloadSpeed: {
    address: 0x0915,
    name: 'LogicReloadSpeed',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Logical interface reload rate',
    quantity: 1,
    unit: '%Pn/min',
    custom: {
      translate: 'logicReloadSpeed',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 6),
    },
  },
  VoltageDerateResponseTime: {
    address: 0x0916,
    name: 'VoltageDerateResponseTime',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Voltage derate time',
    quantity: 1,
    unit: 'Second',
    custom: {
      translate: 'voltageDerateResponseTime',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.RemoteConfig as number), 8),
    },
  },
};

export const V3OverFrequencyUnderFrequencyDerate: Partial<RegisterTable> = {
  FrequencyDerateConfig: {
    address: 0x0940,
    name: 'FrequencyDerateConfig',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
    Bit0：enable, higher frequency power derate
    Bit1：enable, lower frequency power derate
    Bit2：enable, higher frequency power reload
    Bit3：enable, lower frequency power reload
    Bit4：enable,power derate start from rated power
    Bit5：enable,derating slope calculate by current power
    Bit6: Energy storage segmentation curve enable
    Bit7: Maximum power calculation enable
    Bit12-13：derating mode(0: slope mode ;  1:frquency mode)
    `,
    custom: {
      translate: 'frequencyDerateConfig',
      isEnabledFn: (_: Partial<InverterData>) => false,
      bitFunctions: [{
        translate: 'enableHigherFrequencyPowerDerate',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 0),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyDerateConfig as number, bit, 0),
      }, {
        translate: 'enableLowerFrequencyPowerDerate',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 1),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyDerateConfig as number, bit, 1),
      }, {
        translate: 'enableHigherFrequencyPowerReload',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 2),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyDerateConfig as number, bit, 2),
      }, {
        translate: 'enableLowerFrequencyPowerReload',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 3),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyDerateConfig as number, bit, 3),
      }, {
        translate: 'enableDerateStartFromRatedPower',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 4),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyDerateConfig as number, bit, 4),
      }, {
        translate: 'enableDeratingSlopeCalculateByCurrentPower',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 5),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyDerateConfig as number, bit, 5),
      }, {
        translate: 'energyStorageSegmentationCurveEnable',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyDerateConfig as number, bit, 6),
      }, {
        translate: 'maximumPowerCalculationEnable',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 7),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.FrequencyDerateConfig as number, bit, 7),
      }],
      multiBitFunctions: [{
        translate: 'deratingMode',
        selectionFn: (data: Partial<InverterData>) => getBitsValue(data.FrequencyDerateConfig as number, 12, 13),
        updateFn: (data: Partial<InverterData>, value: number) => updateBitsValue(data.FrequencyDerateConfig as number, value, 12, 13),
        selectionLabelMap: {
          0: 'i18n.report.SlopeMode',
          1: 'i18n.report.FrequencyMode',
        },
      }],
    },
    quantity: 1,
    unit: '',
  },
  OverfrequencyStart: {
    address: 0x0941,
    name: 'OverfrequencyStart',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description:
      'the Starting point of power derate leading by higher frequency',
    custom: {
      translate: 'overfrequencyStart',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 0),
    },
    quantity: 1,
    unit: 'Hz',
  },
  OverfrequencyEnd: {
    address: 0x0942,
    name: 'OverfrequencyEnd',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'The ending point of power derate leading by higher frequency',
    custom: {
      translate: 'overfrequencyEnd',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 0),
    },
    quantity: 1,
    unit: 'Hz',
  },
  OverfrequencySlope: {
    address: 0x0943,
    name: 'OverfrequencySlope',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
      the percentage of power derate leading  higher frequency
      German Standard slope=1/(s*fn)
    `,
    custom: {
      translate: 'overfrequencySlope',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 0),
    },
    quantity: 1,
    unit: '%Pn/Hz',
  },
  OverfrequencyResponseDelay: {
    address: 0x0944,
    name: 'OverfrequencyResponseDelay',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'waiting time for power derate leading by higher frequency',
    custom: {
      translate: 'overfrequencyResponseDelay',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 0),
    },
    quantity: 1,
    unit: 'ms',
  },
  OverfrequencyReloadDelay: {
    address: 0x0945,
    name: 'OverfrequencyReloadDelay',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'waiting time for power reload leading by higher frequency',
    custom: {
      translate: 'overfrequencyReloadDelay',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 2),
    },
    quantity: 1,
    unit: 'ms',
  },
  OverfrequencyReloadStart: {
    address: 0x0946,
    name: 'OverfrequencyReloadStart',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description:
      'reload frequency for power reload leading by higher frequency',
    custom: {
      translate: 'overfrequencyReloadStart',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 2),
    },
    quantity: 1,
    unit: 'Hz',
  },
  OverfrequencyReloadSpeed: {
    address: 0x0947,
    name: 'OverfrequencyReloadSpeed',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the percentage of power reload rate leading by higher frequency',
    custom: {
      translate: 'overfrequencyReloadSpeed',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 2),
    },
    quantity: 1,
    unit: '%Pn/min',
  },
  UnderfrequencyStart: {
    address: 0x0948,
    name: 'UnderfrequencyStart',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description:
      'the Starting point of power derate leading by lower frequency',
    custom: {
      translate: 'underfrequencyStart',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 1),
    },
    quantity: 1,
    unit: 'Hz',
  },
  UnderfrequencyEnd: {
    address: 0x0949,
    name: 'UnderfrequencyEnd',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'The ending point of power derate leading by lower frequency',
    custom: {
      translate: 'underfrequencyEnd',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 1),
    },
    quantity: 1,
    unit: 'Hz',
  },
  UnderfrequencySlope: {
    address: 0x094a,
    name: 'UnderfrequencySlope',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
      the percentage of power derate leading  lower frequency
      German Standard slope=1/(s*fn)
    `,
    custom: {
      translate: 'underfrequencySlope',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 1),
    },
    quantity: 1,
    unit: '%Pn/Hz',
  },
  UnderfrequencyResponseDelay: {
    address: 0x094b,
    name: 'UnderfrequencyResponseDelay',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'waiting time for power derate leading by lower frequency',
    custom: {
      translate: 'underfrequencyResponseDelay',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 1),
    },
    quantity: 1,
    unit: 'ms',
  },
  UnderfrequencyReloadDelay: {
    address: 0x094c,
    name: 'UnderfrequencyReloadDelay',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'waiting time for power reload leading by lower frequency',
    custom: {
      translate: 'underfrequencyReloadDelay',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 3),
    },
    quantity: 1,
    unit: 'ms',
  },
  UnderfrequencyReloadStart: {
    address: 0x094d,
    name: 'UnderfrequencyReloadStart',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description:
      'reload frequency for power reload leading by lower frequency',
    custom: {
      translate: 'underfrequencyReloadStart',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 3),
    },
    quantity: 1,
    unit: 'Hz',
  },
  UnderfrequencyReloadSpeed: {
    address: 0x094e,
    name: 'UnderfrequencyReloadSpeed',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the percentage of power reload rate leading by lower frequency',
    custom: {
      translate: 'underfrequencyReloadSpeed',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 3),
    },
    quantity: 1,
    unit: '%Pn/min',
  },
  FrequencyRecoverMax: {
    address: 0x094f,
    name: 'FrequencyRecoverMax',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'Highest frequency to exist load reduction.',
    custom: {
      translate: 'frequencyRecoverMax',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 4),
    },
    quantity: 1,
    unit: 'Hz',
  },
  FrequencyRecoverMin: {
    address: 0x0950,
    name: 'FrequencyRecoverMin',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'lowest frequency to exist load reduction.',
    custom: {
      translate: 'frequencyRecoverMin',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 4),
    },
    quantity: 1,
    unit: 'Hz',
  },
  ESSOverFrequencyStart: {
    address: 0x0951,
    name: 'ESSOverFrequencyStart',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: '(Energy storage) Over-frequency derate start frequency',
    custom: {
      translate: 'eSSOverFrequencyStart',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'Hz',
  },
  ESSOverfrequencyEnd: {
    address: 0x0952,
    name: 'ESSOverfrequencyEnd',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description:
      '(Energy storage) cut-off frequency for over-frequency derate. Frequency range mode is valid',
    custom: {
      translate: 'eSSOverfrequencyEnd',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'Hz',
  },
  ESSOverFrequencySlope: {
    address: 0x0953,
    name: 'ESSOverFrequencySlope',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
      (Energy storage) Over-frequency derate slope percentage. Slope mode is valid
      German standard slope=1/(s*fn)
    `,
    custom: {
      translate: 'eSSOverFrequencySlope',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: '%Pn/Hz',
  },
  ESSOverFrequencyResponseDelay: {
    address: 0x0954,
    name: 'ESSOverFrequencyResponseDelay',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: '(Energy storage) Over-frequency derate start-up waiting time',
    custom: {
      translate: 'eSSOverFrequencyResponseDelay',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'ms',
  },
  ESSOverFrequencyReloadDelay: {
    address: 0x0955,
    name: 'ESSOverFrequencyReloadDelay',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: '(Energy storage) Waiting time before over-frequency reload',
    custom: {
      translate: 'eSSOverFrequencyReloadDelay',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'ms',
  },
  ESSOverfrequencyReloadStart: {
    address: 0x0956,
    name: 'ESSOverfrequencyReloadStart',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: `
      (Energy storage) Over-frequency derate reloading frequency. It takes effect when over-frequency reload is prohibited.
    `,
    custom: {
      translate: 'eSSOverfrequencyReloadStart',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'Hz',
  },
  ESSOverFrequencyReloadSpeed: {
    address: 0x0957,
    name: 'ESSOverFrequencyReloadSpeed',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: '(Energy storage) Over-frequency reload rate percentage',
    custom: {
      translate: 'eSSOverFrequencyReloadSpeed',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: '%Pn/min',
  },
  ESSUnderFrequencyStart: {
    address: 0x0958,
    name: 'ESSUnderFrequencyStart',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: '(Energy storage) Under-frequency derate start frequency',
    custom: {
      translate: 'eSSUnderFrequencyStart',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'Hz',
  },
  ESSUnderfrequencyEnd: {
    address: 0x0959,
    name: 'ESSUnderfrequencyEnd',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description:
      '(Energy storage) cut-off frequency of under-frequency derate. Frequency range mode is valid',
    custom: {
      translate: 'eSSUnderfrequencyEnd',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'Hz',
  },
  ESSUnderFrequencySlope: {
    address: 0x095a,
    name: 'ESSUnderFrequencySlope',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
      (Energy storage) Under-frequency derate slope percentage. Slope mode is valid
      German standard slope=1/(s*fn)
    `,
    custom: {
      translate: 'eSSUnderFrequencySlope',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: '%Pn/Hz',
  },
  ESSUnderFrequencyResponseDelay: {
    address: 0x095b,
    name: 'ESSUnderFrequencyResponseDelay',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: '(Energy storage) Under-frequency derate start-up waiting time',
    custom: {
      translate: 'eSSUnderFrequencyResponseDelay',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'ms',
  },
  ESSUnderFrequencyReloadDelay: {
    address: 0x095c,
    name: 'ESSUnderFrequencyReloadDelay',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: '(Energy storage) Waiting time before under-frequency reload',
    custom: {
      translate: 'eSSUnderFrequencyReloadDelay',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'ms',
  },
  ESSUnderfrequencyReloadStart: {
    address: 0x095d,
    name: 'ESSUnderfrequencyReloadStart',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: `
      (Energy storage) Under-frequency derate reloading frequency. It takes effect when under-frequency reload is prohibited.
    `,
    custom: {
      translate: 'eSSUnderfrequencyReloadStart',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'Hz',
  },
  ESSUnderFrequencyReloadSpeed: {
    address: 0x095e,
    name: 'ESSUnderFrequencyReloadSpeed',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: '(Energy storage) Under-frequency reload rate percentage',
    custom: {
      translate: 'eSSUnderFrequencyReloadSpeed',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: '%Pn/min',
  },
  ESSFrequencyRecoverMax: {
    address: 0x095f,
    name: 'ESSFrequencyRecoverMax',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: '(Energy storage) The highest frequency for exiting derate',
    custom: {
      translate: 'eSSFrequencyRecoverMax',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 4),
    },
    quantity: 1,
    unit: 'Hz',
  },
  ESSFrequencyRecoverMin: {
    address: 0x0960,
    name: 'ESSFrequencyRecoverMin',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: '(Energy storage) The lowest frequency for exiting derate',
    custom: {
      translate: 'eSSFrequencyRecoverMin',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 4),
    },
    quantity: 1,
    unit: 'Hz',
  },
  ESSOverFrequencyTransition: {
    address: 0x0961,
    name: 'ESSOverFrequencyTransition',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: `
      (Energy storage) Over-frequency derate power crosses the frequency point. It is valid when 0940 Bit6 is enabled.
    `,
    custom: {
      translate: 'eSSOverFrequencyTransition',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'Hz',
  },
  ESSUnderFrequencyTransition: {
    address: 0x0962,
    name: 'ESSUnderFrequencyTransition',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: `
      (Energy storage) Under-frequency derate power crosses the frequency point. It is valid when 0940 Bit6 is enabled.
    `,
    custom: {
      translate: 'eSSUnderFrequencyTransition',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.FrequencyDerateConfig as number), 6),
    },
    quantity: 1,
    unit: 'Hz',
  },
};

export const V3ReactivePower: Partial<RegisterTable> = {
  ReactiveConfig: {
    address: 0x0980,
    name: 'ReactiveConfig',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
    Bit0：enable reactive power
    Bit1-3：reactive power mode
    Bit8：enable, reactive mode 3 (voltage mode )
    Bit9: Charge reactive enable
    Bit10: Reactive mode four Austrian enable bit
    `,
    custom: {
      translate: 'reactiveConfig',
      isEnabledFn: (_: Partial<InverterData>) => false,
      bitFunctions: [{
        order: 0,
        translate: 'enableReactivePower',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.ReactiveConfig as number), 0),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.ReactiveConfig as number, bit, 0),
      }, {
        translate: 'enableReactiveMode3',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.ReactiveConfig as number), 8),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.ReactiveConfig as number, bit, 8),
        hide: true,
      }, {
        translate: 'chargeReactiveEnable',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.ReactiveConfig as number), 9),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.ReactiveConfig as number, bit, 9),
        hide: true,
      }, {
        translate: 'reactiveModeFourAustrianEnableBit',
        isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.ReactiveConfig as number), 10),
        updateFn: (data: Partial<InverterData>, bit: boolean) =>  updateBitByPosition(data.ReactiveConfig as number, bit, 10),
        hide: true,
      }],
      multiBitFunctions: [{
        order: 2,
        translate: 'reactivePowerMode',
        selectionFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3),
        updateFn: (data: Partial<InverterData>, value: number) => updateBitsValue(data.ReactiveConfig as number, value, 1, 3),
        selectionLabelMap: {
          [0]: 'i18n.report.ReactiveMode1',
          [1]: 'i18n.report.ReactiveMode2',
          [2]: 'i18n.report.ReactiveMode3',
          [3]: 'i18n.report.ReactiveMode4',
          [4]: 'i18n.report.ReactiveMode5',
          [5]: 'i18n.report.ReactiveMode6',
        },
      }],
    },
    quantity: 1,
    unit: '',
  },
  PowerFactor: {
    address: 0x0981,
    name: 'PowerFactor',
    dataType: DataType.I16,
    accuracy: 0.0001,
    access: ReadWrite.Read,
    description: 'power factor, by using reactive mode 1 to calculate Tanphi',
    quantity: 1,
    order: 1,
    custom: {
      translate: 'powerFactor',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 0,
    },
    unit: '',
  },
  FixedReactivePercentage: {
    address: 0x0982,
    name: 'FixedReactivePercentage',
    dataType: DataType.I16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'fixed percentage pf reactive power, calculate the reactive power by using reactive mode 2',
    order: 3,
    custom: {
      translate: 'fixedReactivePercentage',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 1,
    },
    quantity: 1,
    unit: '%',
  },
  ReactiveCos1: {
    address: 0x0983,
    name: 'ReactiveCos1',
    dataType: DataType.I16,
    accuracy: 0.0001,
    access: ReadWrite.Read,
    description: 'For reactive mode 3，the 1st point power factor',
    order: 4,
    custom: {
      translate: 'reactiveCos1',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 2,
    },
    quantity: 1,
    unit: '',
  },
  ReactivedynamicValue1: {
    address: 0x0984,
    name: 'ReactivedynamicValue1',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 3, the 1st point power percentage',
    order: 5,
    custom: {
      translate: 'reactivedynamicValue1',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 2,
    },
    quantity: 1,
    unit: '%',
  },
  ReactiveCos2: {
    address: 0x0985,
    name: 'ReactiveCos2',
    dataType: DataType.I16,
    accuracy: 0.0001,
    access: ReadWrite.Read,
    description: 'For reactive mode 3，the 2nd point power factor',
    order: 6,
    custom: {
      translate: 'reactiveCos2',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 2,
    },
    quantity: 1,
    unit: '',
  },
  ReactivedynamicValue2: {
    address: 0x0986,
    name: 'ReactivedynamicValue2',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 3, the 2nd point power percentage',
    order: 7,
    custom: {
      translate: 'reactivedynamicValue2',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 2,
    },
    quantity: 1,
    unit: '%',
  },
  ReactiveCos3: {
    address: 0x0987,
    name: 'ReactiveCos3',
    dataType: DataType.I16,
    accuracy: 0.0001,
    access: ReadWrite.Read,
    description: 'For reactive mode 3，the 3rd point power factor',
    order: 8,
    custom: {
      translate: 'reactiveCos3',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 2,
    },
    quantity: 1,
    unit: '',
  },
  ReactivedynamicValue3: {
    address: 0x0988,
    name: 'ReactivedynamicValue3',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 3, the 3rd point power percentage',
    order: 9,
    custom: {
      translate: 'reactivedynamicValue3',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 2,
    },
    quantity: 1,
    unit: '%',
  },
  ReactiveCos4: {
    address: 0x0989,
    name: 'ReactiveCos4',
    dataType: DataType.I16,
    accuracy: 0.0001,
    access: ReadWrite.Read,
    description: 'For reactive mode 3，the 4th point power factor',
    order: 10,
    custom: {
      translate: 'reactiveCos4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 2,
    },
    quantity: 1,
    unit: '',
  },
  ReactivedynamicValue4: {
    address: 0x098a,
    name: 'ReactivedynamicValue4',
    dataType: DataType.I16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 3, the 4th point power percentage',
    order: 11,
    custom: {
      translate: 'reactivedynamicValue4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 2,
    },
    quantity: 1,
    unit: '%',
  },
  LockinV: {
    address: 0x098b,
    name: 'LockinV',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 3，the lochinV voltage percentage',
    order: 12,
    custom: {
      translate: 'lockinV',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 2,
    },
    quantity: 1,
    unit: '%',
  },
  LockoutV: {
    address: 0x098c,
    name: 'LockoutV',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 3，the lochoutV voltage percentage',
    order: 13,
    custom: {
      translate: 'lockoutV',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 2,
    },
    quantity: 1,
    unit: '%',
  },
  HighVoltStartValue4: {
    address: 0x098d,
    name: 'HighVoltStartValue4',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 4, the percentage of higher voltage start up point',
    order: 14,
    custom: {
      translate: 'highVoltStartValue4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: '%',
  },
  HighVoltEndValue4: {
    address: 0x098e,
    name: 'HighVoltEndValue4',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description:
      'For Reactive mode 4, the percentage of higher voltage ending point',
    custom: {
      translate: 'highVoltEndValue4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: '%',
  },
  LowVoltStartValue4: {
    address: 0x098f,
    name: 'LowVoltStartValue4',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'for reactive mode 4 ,the percentage of lower voltage start up point',
    custom: {
      translate: 'lowVoltStartValue4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: '%',
  },
  LowVoltEndValue4: {
    address: 0x0990,
    name: 'LowVoltEndValue4',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 4, the percentage  of lower voltage ending point',
    custom: {
      translate: 'lowVoltEndValue4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: '%',
  },
  LockinPower4: {
    address: 0x0991,
    name: 'LockinPower4',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 4 ，Lockinpower percentage',
    custom: {
      translate: 'lockinPower4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: '%',
  },
  LockoutPower4: {
    address: 0x0992,
    name: 'LockoutPower4',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For Reactive mode 4，Lockout power percentage',
    custom: {
      translate: 'lockoutPower4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: '%',
  },
  MaxLeadingReactivePower4: {
    address: 0x0993,
    name: 'MaxLeadingReactivePower4',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'for Reactive mode 4 , The max reactive power percentage',
    custom: {
      translate: 'maxLeadingReactivePower4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: '%Pn',
  },
  ReactiveResponseWaitTime4: {
    address: 0x0994,
    name: 'ReactiveResponseWaitTime4',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'For Reactive mode 4, waiting time for reactive power response',
    custom: {
      translate: 'reactiveResponseWaitTime4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: 'ms',
  },
  ReactivePowerOffset4: {
    address: 0x0995,
    name: 'ReactivePowerOffset4',
    dataType: DataType.I16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'For Reactive mode4, reactive power offset value',
    custom: {
      translate: 'reactivePowerOffset4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: '%Qmax',
  },
  ReactivePowerStart4: {
    address: 0x0996,
    name: 'ReactivePowerStart4',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description:
      'For reactive mode 4, the percentage of reactive power (higher voltage start point)',
    custom: {
      translate: 'reactivePowerStart4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: '%Pn',
  },
  HighVoltStartValue5: {
    address: 0x0997,
    name: 'HighVoltStartValue5',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 5, the percentage of higher voltage start up point',
    custom: {
      translate: 'highVoltStartValue5',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 4,
    },
    quantity: 1,
    unit: '%',
  },
  HighVoltEndValue5: {
    address: 0x0998,
    name: 'HighVoltEndValue5',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For Reactive mode 5, the percentage of higher voltage ending point',
    custom: {
      translate: 'highVoltEndValue5',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 4,
    },
    quantity: 1,
    unit: '%',
  },
  LowVoltStartValue5: {
    address: 0x0999,
    name: 'LowVoltStartValue5',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'for reactive mode 5 ,the percentage of lower voltage start up point',
    custom: {
      translate: 'lowVoltStartValue5',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 4,
    },
    quantity: 1,
    unit: '%',
  },
  LowVoltEndValue5: {
    address: 0x099a,
    name: 'LowVoltEndValue5',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 5, the percentage  of lower voltage ending point',
    custom: {
      translate: 'lowVoltEndValue5',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 4,
    },
    quantity: 1,
    unit: '%',
  },
  LockinPower5: {
    address: 0x099b,
    name: 'LockinPower5',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For reactive mode 5 ，Lockinpower percentage',
    custom: {
      translate: 'lockinPower5',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 4,
    },
    quantity: 1,
    unit: '%',
  },
  LockoutPower5: {
    address: 0x099c,
    name: 'LockoutPower5',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'For Reactive mode 5，Lockout power percentage',
    custom: {
      translate: 'lockoutPower5',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 4,
    },
    quantity: 1,
    unit: '%',
  },
  MaxReactivePower5: {
    address: 0x099d,
    name: 'MaxReactivePower5',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: 'for Reactive mode 5 , The max reactive power percentage',
    custom: {
      translate: 'maxReactivePower5',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 4,
    },
    quantity: 1,
    unit: '%',
  },
  ReactiveResponseWaitTime5: {
    address: 0x099e,
    name: 'ReactiveResponseWaitTime5',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'For Reactive mode 5, waiting time for reactive power response',
    custom: {
      translate: 'reactiveResponseWaitTime5',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 4,
    },
    quantity: 1,
    unit: 'ms',
  },
  PhaseType: {
    address: 0x099f,
    name: 'PhaseType',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
      For Reactive mode 6 ，phase type
      0：no Reactive power
      1：lagging
      2：leading
    `,
    custom: {
      translate: 'phaseType',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 5,
    },
    quantity: 1,
    unit: '',
  },
  ReactiveResponsePeriod: {
    address: 0x09a0,
    name: 'ReactiveResponsePeriod',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'for reactive mode （1, 2, 3, 4, 5, 6）adjust the time period for reactive power mode',
    order: 1.5,
    custom: {
      translate: 'reactiveResponsePeriod',
      isEnabledFn: (data: Partial<InverterData>) => isEnabledByBit((data.ReactiveConfig as number), 0),
    },
    quantity: 1,
    unit: 'Second',
  },
  MaxLaggingReactivePower4: {
    address: 0x09a1,
    name: 'MaxLaggingReactivePower4',
    dataType: DataType.U16,
    accuracy: 0.01,
    access: ReadWrite.Read,
    description: `
      Reactive power mode four, the maximum lagging reactive power percentage
    `,
    custom: {
      translate: 'maxLaggingReactivePower4',
      isEnabledFn: (data: Partial<InverterData>) => getBitsValue(data.ReactiveConfig as number, 1, 3) === 3,
    },
    quantity: 1,
    unit: '%Pn',
  },
};

export const V3VRTConfig: Partial<RegisterTable> = {
  VRTConfig: {
    address: 0x09c0,
    name: 'VRTConfig',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
      Bit0：LVRT enable bit
      Bit1：OVRT enable bit
      Bit2：0 current mode enable bot
      BIt3：Keep reactive current before VRT
      Bit4: Calculate the current using the voltage before the drop
      Bit5: Negative sequence current enable bit
      Bit6: High through active enable bit
      Bit8-11：VRT current calculation Mode
    `,
    quantity: 1,
    unit: '',
  },
  LvrtInVolt: {
    address: 0x09c1,
    name: 'LvrtInVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'The Voltage percentage (start point,LVRT)',
    quantity: 1,
    unit: '%',
  },
  LvrtFirstPointVolt: {
    address: 0x09c2,
    name: 'LvrtFirstPointVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the voltage percentage  (1st point, LVRT)',
    quantity: 1,
    unit: '%',
  },
  LvrtFirstPointTime: {
    address: 0x09c3,
    name: 'LvrtFirstPointTime',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Time for 1st point ,LVRT',
    quantity: 1,
    unit: 'ms',
  },
  LvrtSecondPointVolt: {
    address: 0x09c4,
    name: 'LvrtSecondPointVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the voltage percentage  (2ND point, LVRT)',
    quantity: 1,
    unit: '%',
  },
  LvrtSecondPointTime: {
    address: 0x09c5,
    name: 'LvrtSecondPointTime',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Time for 2nd point ,LVRT',
    quantity: 1,
    unit: 'ms',
  },
  LvrtThirdPointVolt: {
    address: 0x09c6,
    name: 'LvrtThirdPointVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the voltage percentage  (3rd point, LVRT)',
    quantity: 1,
    unit: '%',
  },
  LvrtThirdPointTime: {
    address: 0x09c7,
    name: 'LvrtThirdPointTime',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Time for 3rd point ,LVRT',
    quantity: 1,
    unit: 'ms',
  },
  LvrtFourthPointVolt: {
    address: 0x09c8,
    name: 'LvrtFourthPointVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the voltage percentage  (4th point, LVRT)',
    quantity: 1,
    unit: '%',
  },
  LvrtFourthPointTime: {
    address: 0x09c9,
    name: 'LvrtFourthPointTime',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Time for 4th point ,LVRT',
    quantity: 1,
    unit: 'ms',
  },
  LvrtReactiveCurrentCoefficientK: {
    address: 0x09ca,
    name: 'LvrtReactiveCurrentCoefficientK',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'Reactive Current Coefficient (K），LVRT',
    quantity: 1,
    unit: 'p.u.',
  },
  LvrtWaitingTimeAfterVoltageRecovery: {
    address: 0x09cb,
    name: 'LvrtWaitingTimeAfterVoltageRecovery',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Waiting time after LVRT Recovery',
    quantity: 1,
    unit: 'ms',
  },
  LvrtPowerBackRate: {
    address: 0x09cc,
    name: 'LvrtPowerBackRate',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Power reload rate  (back from LVRT)',
    quantity: 1,
    unit: '%Pn/min',
  },
  OvrtInVlot: {
    address: 0x09cd,
    name: 'OvrtInVlot',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'The Voltage percentage (start point,OVRT)',
    quantity: 1,
    unit: '%',
  },
  OvrtFirstPointVolt: {
    address: 0x09ce,
    name: 'OvrtFirstPointVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the voltage percentage  (1st point, OVRT)',
    quantity: 1,
    unit: '%',
  },
  OvrtFirstPointTime: {
    address: 0x09cf,
    name: 'OvrtFirstPointTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'Time for 1st point ,OVRT',
    quantity: 1,
    unit: 'ms',
  },
  OvrtSecondPointVolt: {
    address: 0x09d0,
    name: 'OvrtSecondPointVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the voltage percentage  (2ND point, OVRT)',
    quantity: 1,
    unit: '%',
  },
  OvrtSecondPointTime: {
    address: 0x09d1,
    name: 'OvrtSecondPointTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'Time for 2nd point ,OVRT',
    quantity: 1,
    unit: 'ms',
  },
  OvrtThirdPointVolt: {
    address: 0x09d2,
    name: 'OvrtThirdPointVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the voltage percentage  (3rd point, OVRT)',
    quantity: 1,
    unit: '%',
  },
  OvrtThirdPointTime: {
    address: 0x09d3,
    name: 'OvrtThirdPointTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'Time for 3rd point ,OVRT',
    quantity: 1,
    unit: 'ms',
  },
  OvrtFourthPointVolt: {
    address: 0x09d4,
    name: 'OvrtFourthPointVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the voltage percentage  (4th point, OVRT)',
    quantity: 1,
    unit: '%',
  },
  OvrtFourthPointTime: {
    address: 0x09d5,
    name: 'OvrtFourthPointTime',
    dataType: DataType.U16,
    accuracy: 10,
    access: ReadWrite.Read,
    description: 'Time for 4th point ,OVRT',
    quantity: 1,
    unit: 'ms',
  },
  OvrtReactiveCurrentCoefficientK: {
    address: 0x09d6,
    name: 'OvrtReactiveCurrentCoefficientK',
    dataType: DataType.U16,
    accuracy: 0.1,
    access: ReadWrite.Read,
    description: 'Reactive Current Coefficient (K），OVRT',
    quantity: 1,
    unit: 'p.u.',
  },
  OvrtWaitingTimeAfterVoltageRecovery: {
    address: 0x09d7,
    name: 'OvrtWaitingTimeAfterVoltageRecovery',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Waiting time after OVRT Recovery',
    quantity: 1,
    unit: 'ms',
  },
  OvrtPowerBackRate: {
    address: 0x09d8,
    name: 'OvrtPowerBackRate',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Power reload rate  (back from OVRT)',
    quantity: 1,
    unit: '%Pn/min',
  },
  ZeroCurrentModeInLowVolt: {
    address: 0x09d9,
    name: 'ZeroCurrentModeInLowVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description:
      'the percentage to low voltage mode from  zero current mode',
    quantity: 1,
    unit: '%',
  },
  ZeroCurrentModeInHighVolt: {
    address: 0x09da,
    name: 'ZeroCurrentModeInHighVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description:
      'the percentage to high voltage mode from zero current mode',
    quantity: 1,
    unit: '%',
  },
  LvrtOutVolt: {
    address: 0x09db,
    name: 'LvrtOutVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the voltage percentage for LVRT EXIST',
    quantity: 1,
    unit: '%',
  },
  LvrtIqVoltStart: {
    address: 0x09dc,
    name: 'LvrtIqVoltStart',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description:
      'The starting point, voltage percentage for  reactive current calculation(LVRT)',
    quantity: 1,
    unit: '%',
  },
  OvrtOutVolt: {
    address: 0x09dd,
    name: 'OvrtOutVolt',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'the voltage percentage for OVRT EXIST',
    quantity: 1,
    unit: '%',
  },
  OvrtIqVoltStart: {
    address: 0x09de,
    name: 'OvrtIqVoltStart',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description:
      'The starting point, voltage percentage for  reactive current calculation(0VRT)',
    quantity: 1,
    unit: '%',
  },
  MaxIqPct: {
    address: 0x09df,
    name: 'MaxIqPct',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Maximum reactive current percentage',
    quantity: 1,
    unit: '%',
  },
};

export const V3IslandConfig: Partial<RegisterTable> = {
  IslandConfig: {
    address: 0x0a00,
    name: 'IslandConfig',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Bit0：ISLANDING ENABLE BIT',
    quantity: 1,
    unit: '',
  },
  GFCIConfig: {
    address: 0x0a01,
    name: 'GFCIConfig',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Bit0：GFCI enable bit',
    quantity: 1,
    unit: '',
  },
  ISOConfig: {
    address: 0x0a02,
    name: 'ISOConfig',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
      Bit0：Insulation Resistance testing enable bit
      Bit1：ground Testing enable bit
    `,
    quantity: 1,
    unit: '',
  },
  InsulationProtectionValue: {
    address: 0x0a03,
    name: 'InsulationProtectionValue',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Insulation resistance Value',
    quantity: 1,
    unit: 'kΩ',
  },
  IsoLeakageCurrentLimit: {
    address: 0x0a04,
    name: 'IsoLeakageCurrentLimit',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'leakage current limit , PV to ground',
    quantity: 1,
    unit: 'mA',
  },
  GFCILimit: {
    address: 0x0a05,
    name: 'GFCILimit',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Leakage current limit（not to public , can not make change）',
    quantity: 1,
    unit: 'mA/kVA',
  },
  PE_N_Config: {
    address: 0x0a06,
    name: 'PE_N_Config',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: `
      PE and N control register
      Bit0: Off-net PEN short enable bit
      Bit1: N line detection enable bit
    `,
    quantity: 1,
    unit: '',
  },
  IslandDetectSensitivity: {
    address: 0x0a07,
    name: 'IslandDetectSensitivity',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Sensitivity of islanding detection',
    quantity: 1,
    unit: '',
  },
  PEProtectionValue: {
    address: 0x0a08,
    name: 'PEProtectionValue',
    dataType: DataType.U16,
    accuracy: 1,
    access: ReadWrite.Read,
    description: 'Ground fault judgment threshold',
    quantity: 1,
    unit: 'kΩ',
  },
};
